export default {
  HLConfigApi: {
    base: {
      serviceCodes: 'api/hlBaseConfig/serviceCodes',
      baseConfigOptions: 'api/hlBaseConfig/getBaseConfigOptions',
      configPageList: 'api/hlBaseConfig/configPageList',
      saveOrUpdateConfig: 'api/hlBaseConfig/saveOrUpdateConfig',
      delConfigs: 'api/hlBaseConfig/delConfigs',
      changeConfigStatus: 'api/hlBaseConfig/changeConfigStatus',
      getActiveConfig: 'api/hlBaseConfig/getActiveConfig',
      signLog: 'api/hlBaseConfig/signLog',
      accountLogPageList: '/api/hlBaseConfig/accountLogPageList',
    },
    hlAccountApi: {
      checkHeart: 'api/hlAccountApi/checkHeart',
      currentUserIno: 'api/hlAccountApi/currentUserIno',
    },
    callRecord: {
      // 新建通话记录
      pushCallRecord: 'api/callRecordApi/pushCallRecord',
      // 更新通话记录
      updateCallRecord: 'api/callRecordApi/updateCallRecord',
      onCallRelease: 'api/callRecordApi/onCallRelease',
      // 挂断电话
      hangUpRecord: 'api/callRecordApi/hangUpRecord',
      // 获取通话记录
      loadCallRecord: 'api/callRecordApi/loadCallRecord',
      // 创建监听记录
      pushCallRecordMonitorLog: 'api/callRecordApi/pushCallRecordMonitorLog',
      nearlyCallPage: 'api/callRecordApi/nearlyCallPage',
      nearlyCall: 'api/callRecordApi/nearlyCall',
      updateSoundRecording: 'api/callRecordApi/updateSoundRecording',
    },
    aliyunConfig: {
      callApi: '/api/aliyunApi/callApi',
      initData: 'api/aliyunApi/initData',

      createAccount: 'api/aliyunAccountApi/createAccount',
      updateAccount: 'api/aliyunAccountApi/updateAccount',
      delAccount: '/api/aliyunAccountApi/delAccount',
      systemAccountPageList: '/api/aliyunAccountApi/systemAccountPageList',
      delSystemAccountMapping: '/api/aliyunAccountApi/delSystemAccountMapping',
      systemAccounts: '/api/aliyunAccountApi/systemAccounts',
      addSystemAccountsToHLAccount: '/api/aliyunAccountApi/addSystemAccountsToHLAccount',

      // 云话务部分
      accountPageList: 'api/aliyunAccountApi/accountPageList',
      delAccounts: 'api/aliyunAccountApi/delAccounts',

      // 技能组部分
      creatGroup: 'api/aliyunAccountApi/creatGroup',
      updateGroup: 'api/aliyunAccountApi/updateGroup',
      delGroup: 'api/aliyunAccountApi/delGroup',
      //技能组话务
      groupAccountPageList: 'api/aliyunAccountApi/groupAccountPageList',
      delGroupAccountMapping: 'api/aliyunAccountApi/delGroupAccountMapping',
      changeLevel: 'api/aliyunAccountApi/changeLevel',
      // 当前实例的所有座席
      allAccount: 'api/aliyunAccountApi/allAccount',
      addAccountToGroup: 'api/aliyunAccountApi/addAccountToGroup',
      // 呼出号码部分
      groupPhonePageList: 'api/aliyunAccountApi/groupPhonePageList',
      delGroupPhoneMapping: 'api/aliyunAccountApi/delGroupPhoneMapping',
      allPhoneNumbers: 'api/aliyunAccountApi/allPhoneNumbers',
      addPhoneToGroup: 'api/aliyunAccountApi/addPhoneToGroup',

      // RAM部分
      getRAMSecretKeyList: 'api/aliyunRAMApi/getRAMSecretKeyList',
      createRAMSecretKey: 'api/aliyunRAMApi/createRAMSecretKey',
      delRAMSecretKey: 'api/aliyunRAMApi/delRAMSecretKey',
      changeRAMSecretKeyStatus: 'api/aliyunRAMApi/changeRAMSecretKeyStatus',
      delRAMUser: 'api/aliyunRAMApi/delRAMUser',
      createRAMUser: 'api/aliyunRAMApi/createRAMUser',
      updateRAMUser: 'api/aliyunRAMApi/updateRAMUser',
      getDefaultDomain: 'api/aliyunRAMApi/getDefaultDomain'
    },
    ZTEConfig: {
      accountPageList: 'api/ZTEAccountApi/accountPageList',
      createAccount: 'api/ZTEAccountApi/createAccount',
      updateAccount: 'api/ZTEAccountApi/updateAccount',
      delAccount: '/api/ZTEAccountApi/delAccount',
      systemAccountPageList: '/api/ZTEAccountApi/systemAccountPageList',
      delSystemAccountMapping: '/api/ZTEAccountApi/delSystemAccountMapping',
      systemAccounts: '/api/ZTEAccountApi/systemAccounts',
      addSystemAccountsToHLAccount: '/api/ZTEAccountApi/addSystemAccountsToHLAccount',
      delAccounts: '/api/ZTEAccountApi/delAccounts'
    },
    JXYConfig: {
      accountPageList: 'api/JXYAccountApi/accountPageList',
      createAccount: 'api/JXYAccountApi/createAccount',
      updateAccount: 'api/JXYAccountApi/updateAccount',
      delAccount: '/api/JXYAccountApi/delAccount',
      systemAccountPageList: '/api/JXYAccountApi/systemAccountPageList',
      delSystemAccountMapping: '/api/JXYAccountApi/delSystemAccountMapping',
      systemAccounts: '/api/JXYAccountApi/systemAccounts',
      addSystemAccountsToHLAccount: '/api/JXYAccountApi/addSystemAccountsToHLAccount',
      delAccounts: '/api/JXYAccountApi/delAccounts'
    }
  }
}
